import React from "react";
import {Directory} from "../../components/directory/Directory";
import {HomepageContainer} from "./homepageStyles";

export const Homepage = () => (
    <HomepageContainer>
        <h1>Homepage</h1>
        <Directory/>
    </HomepageContainer>
)
